export function PageNotFound(): JSX.Element {
  return <div>404 Not Found</div>;
}
